import firebase from "firebase/compat/app"

export type FirestoreTimestampType = Pick<
  firebase.firestore.Timestamp,
  "seconds" | "nanoseconds"
>

export type LicenseModel = {
  licenseRegistryId: string
  program: string
  product: string
  content: "ALL" | string
  scheduling: Scheduling
}

export type Scheduling = {
  schedulingSetting: SchedulingSetting
  startDate: FirestoreTimestampType | null
  endDate: FirestoreTimestampType | null
}

export enum SchedulingSetting {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  OPEN_WITH_START_DATE = "OPEN_WITH_START_DATE",
  OPEN_WITH_END_DATE = "OPEN_WITH_END_DATE"
}

export enum SiteLicenseType {
  DISTRICT = "DISTRICT",
  SCHOOL = "SCHOOL",
  GRADE = "GRADE"
}

export type SiteLicenseModel = {
  id: string // districtId-grade | districtId-district | schoolId-school
  type?: SiteLicenseType
  groupId: string
  enabled: boolean
  grades?: number[] | "ALL"
  licenses: LicenseModel[]
  createdAt: FirestoreTimestampType
  updateAt: FirestoreTimestampType
}

export type AccountLicense = {
  _updatedAt?: FirestoreTimestampType
  accountId: string
  created: number
  deleted?: boolean
  displayName?: string
  district: string
  endDate: number // UNIX time in seconds
  id: string
  lastModified: number
  licenseSet: string // This is the licenseRegistryId
  licenseType: string
  licensedCount: number
  licensedMax: number
  name: string
  navCategory: string
  navName: string
  startDate: number // Also in UNIX time, if relevant
}

export type LicenseRegistry = {
  content: string
  endDate: null
  id: string
  licenseable: boolean
  product: string
  program: string
  startDate: firebase.firestore.Timestamp // or some Firestore date
  type: string[]
}
